<template>
    <footer class="mt-16 bg-ink text-white md:mt-24">
        <div class="container-page pt-16 pb-8 md:pt-24">
            <div class="flex flex-col gap-10 md:flex-row md:items-end md:justify-between">
                <div>
                    <h2 class="font-display text-[38px] font-semibold leading-[1.05] tracking-[-0.03em] sm:text-[56px]">
                        Let's connect.
                    </h2>
                    <a href="mailto:ege.arslan.dev@gmail.com"
                        class="group mt-5 inline-flex items-center gap-3 text-[18px] text-white/75 transition-colors hover:text-white sm:text-[20px]">
                        ege.arslan.dev@gmail.com
                        <i class="fa-solid fa-arrow-right text-[14px] transition-transform group-hover:translate-x-1"></i>
                    </a>
                </div>

                <div class="flex gap-3">
                    <a v-for="s in socials" :key="s.label" :href="s.href" :target="s.external ? '_blank' : undefined"
                        rel="noopener noreferrer" :aria-label="s.label"
                        class="flex h-12 w-12 items-center justify-center rounded-full border border-white/15 transition-colors hover:border-white hover:bg-white hover:text-ink">
                        <i :class="s.icon" class="text-[18px]"></i>
                    </a>
                </div>
            </div>

            <div class="mt-16 flex flex-col gap-4 border-t border-white/10 pt-6 text-[13px] text-white/50 sm:flex-row sm:items-center sm:justify-between md:mt-20">
                <span>&copy; {{ year }} Ege Arslan</span>
                <nav class="flex gap-6">
                    <router-link v-for="item in footerLinks" :key="item.to" :to="item.to" class="hover:text-white">
                        {{ item.label }}
                    </router-link>
                </nav>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    data() {
        return {
            year: new Date().getFullYear(),
            footerLinks: [
                { label: 'Home', to: '/' },
                { label: 'Mobile Apps', to: '/mobile-apps' },
                { label: 'Projects', to: '/projects' }
            ],
            socials: [
                { label: 'Email', href: 'mailto:ege.arslan.dev@gmail.com', icon: 'fa-solid fa-envelope' },
                { label: 'GitHub', href: 'https://github.com/ArslanEge', icon: 'fa-brands fa-github', external: true },
                { label: 'LinkedIn', href: 'https://www.linkedin.com/in/ege-arslan-981729243/', icon: 'fa-brands fa-linkedin-in', external: true }
            ]
        };
    }
};
</script>
